import { RichUtils } from 'draft-js';

export const resetBlockType = (editorState) => {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();
  const blockType = contentState
    .getBlockForKey(selectionState.getStartKey())
    .getType();

  if (blockType.startsWith('header')) {
    return RichUtils.toggleBlockType(editorState, 'unstyled');
  }

  return editorState;
};
